var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPedestal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432 448H16C7.164 448 0 455.162 0 464V496C0 504.836 7.164 512 16 512H432C440.836 512 448 504.836 448 496V464C448 455.162 440.836 448 432 448ZM416 64C416 28.652 387.346 0 352 0H96C60.654 0 32 28.652 32 64V416H416V64ZM112 96C103.164 96 96 88.836 96 80C96 71.162 103.164 64 112 64S128 71.162 128 80C128 88.836 120.836 96 112 96ZM336 96C327.164 96 320 88.836 320 80C320 71.162 327.164 64 336 64S352 71.162 352 80C352 88.836 344.836 96 336 96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestal);
export default __webpack_public_path__ + "static/media/pedestal.98eef0d5fd3f442f1dcf36799c16d1b0.svg";
export { ForwardRef as ReactComponent };